export default __webpack_public_path__ + "static/media/calculator.be865890.png";